<template>
  <div>
    <v-container fluid>
      <titulo-tool-bar titulo="Configuración" class="rounded-xl"></titulo-tool-bar>
    </v-container>
    <div id="contenedor-configuracion-main" class="d-flex">
      <div id="catalog-menu"
        style="position: sticky; top: 60px; overflow-y: auto; min-width: 250px;"
        class="mt-3 ml-2 rounded-lg">
        <v-list dense nav>
          <v-subheader class="title">Catálogos</v-subheader>
          <template v-for="(entry, index) in menu">
            <v-subheader
              v-if="entry.type === 'header'"
              :key="'h-' + index"
            >
              {{ entry.title }}
            </v-subheader>
            <v-divider v-else-if="entry.type === 'divider'" :key="'d-' + index" class="my-1" />
            <v-list-item
              v-else
              :key="'i-' + index"
              :to="{ name: entry.ruta }"
              link
            >
              <v-list-item-icon>
                <v-icon color="grey darken-1">{{ entry.icono }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="entry.nombre" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </div>
      <div id="catalog-content" style="flex: 1;">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import TituloToolBar from '@/components/TituloToolBar.vue';

export default {
  name: 'ConfiguracionMain',
  components: {
    TituloToolBar,
  },
  data() {
    return {
      menu: [
        // Ubicación
        { type: 'header', title: 'Ubicación' },
        {
          ruta: 'catalogoEntidades',
          nombre: 'Entidades',
          scopes: 'Catálogos:ver',
          icono: 'mdi-domain',
          divisor: false,
          children: [],
        },
        {
          ruta: 'catalogoMunicipios',
          nombre: 'Municipios',
          scopes: 'Catálogos:ver',
          icono: 'mdi-map-marker',
          divisor: false,
          children: [],
        },
        {
          ruta: 'CatalogoLocalidadesView',
          nombre: 'Localidades',
          scopes: 'Catálogos:ver',
          icono: 'mdi-map-marker-multiple',
          divisor: false,
          children: [],
        },
        {
          ruta: 'CatalogoColoniasView',
          nombre: 'Colonias',
          scopes: 'Catálogos:ver',
          icono: 'mdi-home-group',
          divisor: false,
          children: [],
        },
        { type: 'divider' },

        // Clasificación
        { type: 'header', title: 'Clasificación' },
        {
          ruta: 'catalogoProgramasInversion',
          nombre: 'Programas de Inversión',
          scopes: 'Catálogos:ver',
          icono: 'mdi-finance',
          divisor: false,
          children: [],
        },
        {
          ruta: 'CatalogoSubprogramasView',
          nombre: 'Subprogramas',
          scopes: 'Catálogos:ver',
          icono: 'mdi-sitemap',
          divisor: false,
          children: [],
        },
        {
          ruta: 'CatalogoPartidasContablesView',
          nombre: 'Partidas Contables',
          scopes: 'Catálogos:ver',
          icono: 'mdi-notebook',
          divisor: false,
          children: [],
        },
        {
          ruta: 'catalogoFuentesFinancieras',
          nombre: 'Fuentes Financieras',
          scopes: 'Catálogos:ver',
          icono: 'mdi-bank',
          divisor: false,
          children: [],
        },
        {
          ruta: 'catalogoTiposObra',
          nombre: 'Tipos de Obra',
          scopes: 'Catálogos:ver',
          icono: 'mdi-tools',
          divisor: false,
          children: [],
        },
        {
          ruta: 'catalogoSubTiposObra',
          nombre: 'Sub Tipos de Obra',
          scopes: 'Catálogos:ver',
          icono: 'mdi-format-list-bulleted-type',
          divisor: false,
          children: [],
        },
        {
          ruta: 'CatalogoGruposObrasView',
          nombre: 'Grupos de Obra',
          scopes: 'Catálogos:ver',
          icono: 'mdi-layers',
          divisor: false,
          children: [],
        },
        {
          ruta: 'CatalogoSubgruposObrasView',
          nombre: 'Subgrupos de Obra',
          scopes: 'Catálogos:ver',
          icono: 'mdi-layers-outline',
          divisor: false,
          children: [],
        },
        {
          ruta: 'CatalogoContratosEventosView',
          nombre: 'Contratos Eventos',
          scopes: 'Catálogos:ver',
          icono: 'mdi-file-document-box-multiple',
          divisor: false,
          children: [],
        },
        { type: 'divider' },

        // Seguridad
        { type: 'header', title: 'Seguridad' },
        {
          ruta: 'catalogoFuncionarios',
          nombre: 'Funcionarios',
          scopes: 'Catálogos:ver',
          icono: 'mdi-account-tie',
          divisor: false,
          children: [],
        },
        {
          ruta: 'catalogoUsuarios',
          nombre: 'Usuarios',
          scopes: 'Seguridad:ver',
          icono: 'mdi-account-multiple',
          divisor: false,
          children: [],
        },
        { type: 'divider' },

        // Contratos
        { type: 'header', title: 'Contratos' },
        {
          ruta: 'catalogoContratistas',
          nombre: 'Contratistas',
          scopes: 'Catálogos:ver',
          icono: 'mdi-briefcase-account',
          divisor: false,
          children: [],
        },
        {
          ruta: 'catalogoDeducciones',
          nombre: 'Deducciones',
          scopes: 'Catálogos:ver',
          icono: 'mdi-calculator',
          divisor: false,
          children: [],
        },
        {
          ruta: 'catalogoContratosEstatus',
          nombre: 'Contratos Estatus',
          scopes: 'Catálogos:ver',
          icono: 'mdi-clipboard-list',
          divisor: false,
          children: [],
        },
        {
          ruta: 'catalogoEtiquetas',
          nombre: 'Etiquetas',
          scopes: 'Catálogos:ver',
          icono: 'mdi-tag-multiple',
          divisor: false,
          children: [],
        },
        {
          ruta: 'catalogoExpedientes',
          nombre: 'Expediente',
          scopes: 'Catálogos:ver',
          icono: 'mdi-folder-open',
          divisor: false,
          children: [],
        },
      ],
    };
  },
  mounted() {
  },
};
</script>

<style lang="scss">

</style>
